/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Blank_Frames_Success_ToastInputs */

const en_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserting blank frames finished successfully`)
};

const fr_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertion de frames vides terminee avec succes`)
};

const de_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Einfügen der leeren Rahmen wurde erfolgreich abgeschlossen.`)
};

const it_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserimento di cornici vuote completato con successo`)
};

const ru_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставка пустых рамок успешно завершена.`)
};

const es_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La inserción de marcos en blanco finalizó correctamente`)
};

const zh_cn2_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白框插入完成`)
};

const ja_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白フレームの挿入が正常に完了しました`)
};

const hi_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम डालने की प्रक्रिया सफलतापूर्वक पूरी हो गई।`)
};

const pt_pt2_iframe_remote_blank_frames_success_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A inserção das molduras em branco foi concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Inserting blank frames finished successfully" |
*
* @param {Iframe_Remote_Blank_Frames_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_blank_frames_success_toast = /** @type {((inputs?: Iframe_Remote_Blank_Frames_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Blank_Frames_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_blank_frames_success_toast(inputs)
	if (locale === "de") return de_iframe_remote_blank_frames_success_toast(inputs)
	if (locale === "it") return it_iframe_remote_blank_frames_success_toast(inputs)
	if (locale === "ru") return ru_iframe_remote_blank_frames_success_toast(inputs)
	if (locale === "es") return es_iframe_remote_blank_frames_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_blank_frames_success_toast(inputs)
	if (locale === "ja") return ja_iframe_remote_blank_frames_success_toast(inputs)
	if (locale === "hi") return hi_iframe_remote_blank_frames_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_blank_frames_success_toast(inputs)
	return en_iframe_remote_blank_frames_success_toast(inputs)
});